<template>
  <section class="content">
   <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
    <DataTable ref="po"
      :value="balanceBroughtDownSettlementLists"
      :paginator="true"
      :rows="10"  :filters="filters"
      class="p-datatable-responsive-demo">
      <Column header="S.n" >
      <template #body="slotProps">
        {{slotProps.index+1}}
      </template>
      </Column>
      <Column
        header="Nature" :sortable="true"
        field="accountNatureName"
        filterMatchMode="contains"
      >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['accountNatureName']" />
        </template>
      </Column>
      <Column :sortable="true"  
        header="Group"
        field="accountHeadName"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountHeadName']" />
        </template>
      </Column>
      <Column :sortable="true"  
        header="Sub Group"
        field="accountSubHeadName"
        filterMatchMode="contains"
      >
       <template #filter>
         <InputText type="text" class="p-column-filter" v-model="filters['accountSubHeadName']" />
       </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains" >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['name']" />
      </template>
      </Column>
      <Column
        header="Short Name"
        field="shortName"
        filterMatchMode="contains"
      >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['shortName']" />
      </template>
      </Column>
      <Column :sortable="true"
        header="Balance"
        field="closingBalance"
        filterMatchMode="contains"
        bodyStyle="text-align: right"
      >
        <template #body="slotProps">
          {{slotProps.data.closingBalance < 0? slotProps.data.closingBalance * (-1):slotProps.data.closingBalance}}
        </template>
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']" />
      </template>
      </Column>

      <Column :sortable="true"
        header="Dr-Cr"
        field="drCr"
        filterMatchMode="contains"
      >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['drCr']" />
      </template>
      </Column>
    </DataTable>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-10"></div>
        <div class="p-field p-col-12 p-md-2 p-mt-2">
          <Button style="float:right"  class="p-button-raised p-button-success" label="Settle"
           @click.prevent="saveBroughtDown()"/>
           <!-- <Button v-else disabled style="float:right"  class="p-button-raised p-button-success" label="Settle"
           @click.prevent="settleSales()"/> -->
         </div>
       </div>
  <!-- <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/> -->
  </div>
</section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'balanceBroughtDownSettlementList',
  data () {
    return {
      columnList: '',
      filters: {},
      loading: false
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button
  },
  computed: {
    balanceBroughtDownSettlementLists() {
      return this.$store.state.finalYearSettlement.balanceBroughtDownSettlementLists
    }
  },
  mounted() {
    this.balanceBroughtDownSettlementList()
    this.columnNames()
  },
  methods: {
    async balanceBroughtDownSettlementList() {
      try {
        await this.$store.dispatch('loadBalanceBroughtDownList')
      } catch (e) {}
    },
    async saveBroughtDown() {
      let resp = ''
      this.loading = true
      resp = await this.$store.dispatch('saveBalanceBroughtDown')
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
        this.unSettleSalesChildHeaderLists = []
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      }
      this.loading = false
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'accountList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// balanceBroughtDown.vue?6dff6675